import React from "react";

/**
 * Placeholder App Store / Google Play badges.
 * NOTE: no real store links yet — they point to the SmartTrace consumer portal
 * for now and should be replaced with real store URLs when available.
 */
const STORE_URL = "https://trace-passport-ci.preview.emergentagent.com/";

const AppleGlyph = ({ className = "" }) => (
  <svg viewBox="0 0 384 512" className={className} fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
  </svg>
);

const PlayGlyph = ({ className = "" }) => (
  <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
    <path fill="#34A853" d="M325 234 79 476c9 5 21 5 33-1l288-166z"/>
    <path fill="#FBBC04" d="m420 256-72-41-79 78 79 78 72-41c22-13 22-61 0-74z"/>
    <path fill="#EA4335" d="M79 36c-3 5-4 12-4 20v392c0 8 1 15 4 20l257-256z"/>
    <path fill="#4285F4" d="M325 234 112 37C100 31 88 31 79 36l257 257z"/>
  </svg>
);

const Badge = ({ children, testid, onDark }) => (
  <a
    href={STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`inline-flex items-center gap-3 rounded-xl px-5 py-2.5 transition-transform hover:scale-[1.03] active:scale-95 ${
      onDark ? "bg-white text-diallo-charcoal" : "bg-diallo-charcoal text-white"
    }`}
  >
    {children}
  </a>
);

export default function AppStoreBadges({ className = "", onDark = false }) {
  const sub = onDark ? "text-diallo-ink/50" : "text-white/70";
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      <Badge testid="badge-app-store" onDark={onDark}>
        <AppleGlyph className="h-7 w-7" />
        <span className="text-left leading-tight">
          <span className={`block text-[10px] uppercase tracking-wide ${sub}`}>Télécharger sur</span>
          <span className="block font-display font-semibold text-base">App Store</span>
        </span>
      </Badge>
      <Badge testid="badge-google-play" onDark={onDark}>
        <PlayGlyph className="h-6 w-6" />
        <span className="text-left leading-tight">
          <span className={`block text-[10px] uppercase tracking-wide ${sub}`}>Disponible sur</span>
          <span className="block font-display font-semibold text-base">Google Play</span>
        </span>
      </Badge>
    </div>
  );
}
